import { useUserConfig } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { YStack } from '@/components/ui';

export const GmailArchiveSettings = observer(() => {
  'use no memo';

  const config = useUserConfig();

  return (
    <YStack className="gap-2 border-t border-border px-2 pt-2 pb-1">
      <label
        htmlFor="home-gmail-auto-archive"
        className="text-xs font-medium text-foreground-muted"
      >
        Archive in Gmail
      </label>
      <select
        id="home-gmail-auto-archive"
        value={config.feed.get('gmail_auto_archive') ?? 'off'}
        onChange={(event) => {
          const value = event.target.value;
          if (
            value === 'off' ||
            value === 'reply' ||
            value === 'reply_and_dismiss'
          ) {
            config.feed.set('gmail_auto_archive', value);
          }
        }}
        className="w-full rounded-md border border-border bg-background px-2 py-1.5 text-sm text-foreground"
      >
        <option value="off">Off</option>
        <option value="reply">On reply</option>
        <option value="reply_and_dismiss">On reply and dismiss</option>
      </select>
      <p className="text-xs text-foreground-muted">
        Archives emails after you send or dismiss a Gmail reply card. Dismissals
        wait at least 10 seconds for Undo. Restoring a card later won’t move
        emails back to your inbox.
      </p>
    </YStack>
  );
});
